// Icons of the app's own (non-work-context) sections. Shared by the side nav
// and the main header title so the same section reads identically in both.
export const NAV_SECTION_ICON = {
  PLANNER: 'edit_calendar',
  SCHEDULE: 'schedule',
  BOARDS: 'grid_view',
  HABITS: 'heart_check',
  SEARCH: 'search',
  SCHEDULED_LIST: 'list',
  DONATE: 'favorite',
  SETTINGS: 'settings',
  ARCHIVED_PROJECTS: 'archive',
} as const;
